import { CardBackLayout } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

import CARD_BACK_TYPOGRAPHY from './images/typography.png';
import CARD_BACK_MONOGRAM from './images/monogram.png';
import CARD_BACK_BLANK from './images/blank.png';
import CARD_BACK_KINDLYRSVP from './images/kindly_rsvp.back.png';
import CARD_BACK_THEDETAILS from './images/the_details.back.png';
import CARD_BACK_LETSCELEBRATE from './images/lets_celebrate.back.png';
// Thank You Cards
import CARD_BACK_ADORABLE_THANK_YOU from './images/adorable.thankyou.jpeg';
import CARD_BACK_MANY_THANKS_THANK_YOU from './images/many_thanks.thankyou.jpeg';
import CARD_BACK_MONOGRAM_THANK_YOU from './images/monogram.thankyou.jpeg';
import CARD_BACK_NAMES_THANK_YOU from './images/names.thankyou.jpeg';
import CARD_BACK_PHOTO_BLANK_THANK_YOU from './images/photo_blank.thankyou.jpeg';
import CARD_BACK_PHOTO_NOTE_THANK_YOU from './images/photo_note.thankyou.jpeg';

import cardBackTypography from './json/back.typography.invite.json';
import cardBackMonogram from './json/back.monogram.invite.json';
import cardBackKindlyRsvp from './json/kindly_rsvp.back.json';
import cardBackTheDetails from './json/the_details.back.json';
import cardBackLetsCelebrate from './json/lets_celebrate.back.json';

// Thank You Cards
import cardBackAdorableThankYou from './json/adorable.thankyou.json';
import cardBackManyThanksThankYou from './json/many_thanks.thankyou.json';
import cardBackMonogramThankYou from './json/monogram.thankyou.json';
import cardBackNamesThankYou from './json/names.thankyou.json';
import cardBackPhotoBlankThankYou from './json/photo_blank.thankyou.json';
import cardBackPhotoNoteThankYou from './json/photo_note.thankyou.json';

export const LAYOUT_TO_NAME = {
  [CardBackLayout.typography]: 'Typography',
  [CardBackLayout.monogram]: 'Monogram',
  [CardBackLayout.kindly_rsvp]: 'Kindly RSVP',
  [CardBackLayout.the_details]: 'The Details',
  [CardBackLayout.lets_celebrate]: "Let's Celebrate",
  [CardBackLayout.blank]: 'Blank',
  [CardBackLayout.adorable_thank_you]: 'Adorable',
  [CardBackLayout.many_thanks_thank_you]: 'Many Thanks',
  [CardBackLayout.monogram_thank_you]: 'Monogram',
  [CardBackLayout.names_thank_you]: 'Names',
  [CardBackLayout.photo_blank_thank_you]: 'Photo Blank',
  [CardBackLayout.photo_note_thank_you]: 'Photo Note'
} as const;

export const LAYOUT_TO_IMAGE = {
  [CardBackLayout.typography]: CARD_BACK_TYPOGRAPHY,
  [CardBackLayout.monogram]: CARD_BACK_MONOGRAM,
  [CardBackLayout.kindly_rsvp]: CARD_BACK_KINDLYRSVP,
  [CardBackLayout.the_details]: CARD_BACK_THEDETAILS,
  [CardBackLayout.lets_celebrate]: CARD_BACK_LETSCELEBRATE,
  [CardBackLayout.blank]: CARD_BACK_BLANK,
  [CardBackLayout.adorable_thank_you]: CARD_BACK_ADORABLE_THANK_YOU,
  [CardBackLayout.many_thanks_thank_you]: CARD_BACK_MANY_THANKS_THANK_YOU,
  [CardBackLayout.monogram_thank_you]: CARD_BACK_MONOGRAM_THANK_YOU,
  [CardBackLayout.names_thank_you]: CARD_BACK_NAMES_THANK_YOU,
  [CardBackLayout.photo_blank_thank_you]: CARD_BACK_PHOTO_BLANK_THANK_YOU,
  [CardBackLayout.photo_note_thank_you]: CARD_BACK_PHOTO_NOTE_THANK_YOU
} as const;

export const LAYOUT_TO_JSON = {
  [CardBackLayout.typography]: cardBackTypography,
  [CardBackLayout.monogram]: cardBackMonogram,
  [CardBackLayout.kindly_rsvp]: cardBackKindlyRsvp,
  [CardBackLayout.the_details]: cardBackTheDetails,
  [CardBackLayout.lets_celebrate]: cardBackLetsCelebrate,
  [CardBackLayout.blank]: [],
  [CardBackLayout.adorable_thank_you]: cardBackAdorableThankYou,
  [CardBackLayout.many_thanks_thank_you]: cardBackManyThanksThankYou,
  [CardBackLayout.monogram_thank_you]: cardBackMonogramThankYou,
  [CardBackLayout.names_thank_you]: cardBackNamesThankYou,
  [CardBackLayout.photo_blank_thank_you]: cardBackPhotoBlankThankYou,
  [CardBackLayout.photo_note_thank_you]: cardBackPhotoNoteThankYou
} as const;
